<template>
    <v-card flat>
        <v-card-title>
            <div class="font-size-16 font-weight-600">Pilih Bundle Subtes</div>
            <v-spacer />

            <v-btn icon @click="$router.push('/ambis-test/create-bundle')">
                <v-icon>mdi-plus</v-icon>
            </v-btn>

            <v-btn icon @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pt-3">
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                placeholder="Masukan kata kunci pencarian"
                dense
                outlined
                class="mb-3"
                hide-details
            ></v-text-field>

            <v-data-table
                :headers="headers"
                :items="bundles"
                :search="search"
                :loading="loading"
            >
                <template v-slot:item.actions="{ item }">
                    <v-btn
                        small
                        depressed
                        color="blew"
                        dark
                        @click="$emit('select', item)"
                    >
                        Pilih
                    </v-btn>
                </template>

                <template v-slot:no-results>
                    <div class="text-center">
                        <p class="my-2">Hasil pencarian tidak ditemukan.</p>
                    </div>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            loading: false,
            search: null,
            headers: [
                { text: "Kode", value: "bundle_code" },
                { text: "Nama", value: "name" },
                { text: "Deskripsi", value: "description" },
                { text: "Jumlah Soal", value: "total_questions", width: 150 },
                { text: "Aksi", value: "actions", sortable: false },
            ],
            bundles: [],
        };
    },

    mounted() {
        this.getBundles();
    },

    methods: {
        async getBundles() {
            const self = this;
            self.loading = true;

            const url = `${process.env.API_BASE_URL}ambis-test/test-tryouts`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            try {
                const response = await axios.get(url, options);
                self.bundles = response.data;
            } catch (error) {
                self.$store.commit("alert/showAlert", {
                    type: "error",
                    message: "Data bundles subtes tidak tersedia",
                });
            } finally {
                self.loading = false;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// DialogSelectBundleSubtest.vue?4d6b5a61